export const LINE_PATH_FOR_CHECK = '/line'
